import { ConnectedAudiologistSortByParam, GetAudiologistsOfSupplierParams } from "@bvhi/backend-api/apis";

export const defaultAudiologistFilter: GetAudiologistsOfSupplierParams = {
  page: 0,
  size: 25,
  sort: [ConnectedAudiologistSortByParam.CHAIN_NUMBER_ASC],
  statuses: ["ACTIVE"],
};
